import { Component } from '@angular/core';
import { HeroComponent } from '../../home/components/hero/hero.component';
import { ExpertiseComponent } from '../../home/components/expertise/expertise.component';
import { TestimonialsComponent } from '../../home/components/testimonials/testimonials.component';
import { CaseStudiesComponent } from '../../home/components/case-studies/case-studies.component';
import { ContactCtaComponent } from '../../home/components/contact-cta/contact-cta.component';
import { LogoStripComponent } from '../../home/components/logo-strip/logo-strip.component';
import {CareersPageComponent} from "../careers/careers-page.component";
import {BlogPageComponent} from "../blog/blog-page.component";
import {ServicesPageComponent} from "../services/services-page.component";
import {AboutPageComponent} from "../about/about-page.component";
import {PricingComponent} from "../../home/components/pricing/pricing.component";

@Component({
  selector: 'app-home-page',
  standalone: true,
  imports: [
    HeroComponent,
    ExpertiseComponent,
    TestimonialsComponent,
    CaseStudiesComponent,
    ContactCtaComponent,
    LogoStripComponent,
    CareersPageComponent,
    BlogPageComponent,
    ServicesPageComponent,
    AboutPageComponent,
    PricingComponent
  ],
  template: `
    <app-hero></app-hero>

    <main class="container stack">
      <app-about-page></app-about-page>
      <app-services-page></app-services-page>
      <app-blog-page></app-blog-page>
      <app-careers-page></app-careers-page>
      <app-pricing></app-pricing>
      <app-expertise></app-expertise>
      <app-testimonials></app-testimonials>
      <app-logo-strip></app-logo-strip>
      <app-contact-cta></app-contact-cta>
    </main>
  `,
  styles: [`
    /* A single place to control spacing between blocks */
    .stack{
      display:flex;
      flex-direction:column;
      gap: 16px;         /* desktop gap between components */
      padding: 18px 0 28px;
    }

    @media (max-width: 960px){
      .stack{
        gap: 14px;
        padding: 16px 0 24px;
      }
    }

    @media (max-width: 560px){
      .stack{
        gap: 12px;       /* tighter on phones */
        padding: 14px 0 18px;
      }
    }
  `]
})
export class HomePageComponent {}
